export enum EOrientation {
  HORIZONTAL = 'horizontal',
  VERTICAL = 'vertical',
}
